import {identity} from '@packages/utilities/fp/utils';
import {getString} from '@packages/utilities/json';
import {Plugins, TypeImplementation, Result} from '@packages/systems/wfdl';
import {call1, _$, tyfun, func, $} from '@packages/utilities/wfdl-helpers';
import * as wast from '@packages/systems/wfdl-ast';
import * as wq from '@packages/systems/wfdl-Qualified';
import LinkIcon from './icons/Link';
import {createSharedTextPluginValues} from '@packages/systems/plugins/Text';
import {
  makeRenderFunction,
  makeOptionalAlias,
} from '@packages/systems/plugins-utils/ValidatedTextInput';
import {isValidLink} from '@packages/utilities/form-validation';

export const TLink = wast.TTypeConstructor(
  wq.qualify(Plugins.name('Link'), wq.typeName('Link'))
);

export const TOptionalLink = wast.TTypeConstructor(
  wq.qualify(Plugins.name('Link'), wq.typeName('Optional Link'))
);

export const plugin = Plugins.PrivilegedPlugin({
  dataTypes: {
    Link: TypeImplementation.Custom({
      parseValue: (json) => {
        const str = getString(json);
        if (str === undefined)
          return Result.Error('Expected a string for Link.');
        return isValidLink(str)
          ? Result.Ok(str)
          : Result.Error('Expected a valid Link literal.');
      },
      render: makeRenderFunction('Link'),
      icon: TypeImplementation.IconByName(
        wq.qualify(wq.pluginName('Link'), wq.iconName('Link'))
      ),
    }),
    'Optional Link': makeOptionalAlias('Link'),
  },

  values: {
    ...createSharedTextPluginValues(TLink, [
      'Equals',
      'Does not equal',
      'Contains',
      'Does not contain',
      'Starts with',
      'Does not start with',
      'Ends with',
      'Does not end with',
    ]),
    'Parse Link': {
      envType: {
        dataType: wast.functionOf(
          wast.TText,
          wast.TUnion({
            Error: wast.TText,
            Ok: TLink,
          })
        ),
        exported: 'hidden',
      },
      // @ts-expect-error - TS7006 - Parameter 'inputText' implicitly has an 'any' type.
      value: (inputText) =>
        isValidLink(inputText)
          ? {tag: 'Ok', val: inputText}
          : {
              tag: 'Error',
              val: 'Should be a valid url like "http://webflow.com"',
            },
    },

    'To Text': {
      envType: {
        dataType: wast.functionOf(TLink, wast.TText),
        exported: 'visible',
        implicit: 'prefilledArgs',
      },
      value: identity,
    },

    'Option Link to Text': {
      envType: {
        dataType: tyfun([wast.TText, TOptionalLink], wast.TText),
        implicit: 'prefilledArgs',
        exported: 'visible',
      },
      expression: func(
        [wq.identifier('fallback text'), wq.identifier('optional link')],
        wast.ECase({
          value: $('optional link'),
          cases: {
            Some: _$('Link', 'To Text'),
            None: func([wq.identifier('_')], $('fallback text')),
          },
        })
      ),
    },
  },

  icons: {
    Link: LinkIcon,
  },
});

export const parseLinkRef = _$('Link', 'Parse Link');
export const parseLink = call1(parseLinkRef);
